import { Visacheck1 } from "../../../../src/components/images/support/visa/Visacheck1.generated";
import { Visahistory1 } from "../../../../src/components/images/support/visa/Visahistory1.generated";
import * as React from 'react';
export default {
  Visacheck1,
  Visahistory1,
  React
};